const reloadPageStyle = () => ({
	wrapper: {
		width: '100%',
		textAlign: 'center',
		'& > div ': {
			maxWidth: '302px',
			margin: '0 auto 33px auto',
		},
	},
});

export default reloadPageStyle;
